import LeaseDetailsSection, { LeaseDetailsSectionProps } from './LeaseDetailsSection';

export type { LeaseDetailsSectionProps };
export default LeaseDetailsSection;
